export const RESORTPASS_PRODUCT_NAMES = ['resort_pass_gold', 'resort_pass_silver'];
